import { Store, SerializedData } from "bernie-core";
import { observable } from "mobx";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { ExtendedContextStore } from "../typings/flexFramework/FlexDefinitions";
import { CampaignProductType, CampaignRecommendationsWithOffersQuery } from "../../__generated__/api";
import { BexApiService } from "../services/BexApiService";
import { getBexApiContext } from "bernie-context";
import Campaigns = CampaignRecommendationsWithOffersQuery.Campaigns;
import { FAILED_CAMPAIGN_FETCH } from "../config/systemEvents";

export class MerchCampaignsStore extends Store {
  @observable
  public campaigns?: Campaigns[];
  public bexApiService: BexApiService;
  @observable
  public isLoading: boolean = true;
  public isLastPage: boolean = false;
  public referrerId: string | null;

  private pageNumber: number;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, bexApiService: BexApiService) {
    super(state, logger);
    this.bexApiService = bexApiService;
    this.campaigns = [];
    this.pageNumber = 1;
    this.referrerId = null;
  }

  public hydrate(data: SerializedData): void {
    // The serialized store as returned by the server exposes a stripped down
    // version of bexApiService with no methods.We delete it here to prevent the override.
    delete data.bexApiService;
    Object.assign(this, data);
  }

  public fetchRecommendedCampaigns = async (
    contextStore: ExtendedContextStore,
    numberOfCampaigns: number,
    maxNumberOfCampaigns: number | null,
    productTypes: string[],
    userLatitude: number,
    userLongitude: number
  ) => {
    const variables: CampaignRecommendationsWithOffersQuery.Variables = {
      context: getBexApiContext(contextStore),
      numCampaigns: numberOfCampaigns,
      maxNumberOfCampaigns,
      pageNumberOfCampaigns: this.pageNumber++,
      productType: this.mapCampaignProductTypes(productTypes),
      userLocation: {
        userLatitude,
        userLongitude
      },
      referrer: this.referrerId
    };

    this.isLoading = true;

    try {
      const query = await this.bexApiService.fetchCampaignRecommendationsWithOffersQuery(variables);

      if (
        query.data.campaignRecommendations?.campaigns &&
        query.data.campaignRecommendations.campaigns.length > 0 &&
        this.campaigns
      ) {
        this.campaigns = this.campaigns.concat(query.data.campaignRecommendations.campaigns);
        this.referrerId = query.data.campaignRecommendations.paginationInfo.referrer;
      } else {
        this.isLastPage = true;
      }
    } catch (err) {
      this.isLastPage = true;
      this.logger.logEvent(FAILED_CAMPAIGN_FETCH, "Unexpected error when fetching recommended campaigns", err);
    }

    this.isLoading = false;
  };

  private mapCampaignProductTypes(productTypes: string[]): CampaignProductType[] | [] {
    return productTypes?.map((product: CampaignProductType) => {
      return CampaignProductType[product.toUpperCase()];
    });
  }
}
